import { useState } from 'react';
import { Link } from 'react-router-dom';
import './ServicesPage.css';
import appleLogo from '../pics/apple.png';
import samsungLogo from '../pics/samsung.png';

const svgProps = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' };
const ScreenIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><rect x="5" y="2" width="14" height="20" rx="2"/><circle cx="12" cy="17" r="1" fill="currentColor" stroke="none"/></svg>);
const BatteryIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><rect x="2" y="7" width="16" height="10" rx="2"/><path d="M22 11v2M7 12h4M9 10v4"/></svg>);
const LightningIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>);
const CameraIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>);
const GlassIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><rect x="3" y="3" width="18" height="18" rx="3"/><path d="M3 9h18M9 21V9"/></svg>);
const WaterIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M12 2c0 0-7 9-7 13a7 7 0 0014 0c0-4-7-13-7-13z"/></svg>);
const SpeakerIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07"/></svg>);
const ButtonIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="4"/></svg>);
const PhoneIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 8.81a19.79 19.79 0 01-3.07-8.63A2 2 0 012 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.11 7.3a16 16 0 006.59 6.59l1.36-1.14a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14.92z"/></svg>);
const TabletIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><rect x="4" y="2" width="16" height="20" rx="2"/><circle cx="12" cy="17" r="1" fill="currentColor" stroke="none"/></svg>);
const GamepadIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><rect x="2" y="6" width="20" height="12" rx="2"/><path d="M6 12h4M8 10v4M15 13h.01M18 11h.01"/></svg>);
const DiscIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/><path d="M12 9v-4M12 19v-4M9 12H5M19 12h-4"/></svg>);
const MonitorIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>);
const SearchIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>);
const WrenchIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>);
const ShieldIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>);
const DollarIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>);

const categories = [
  {
    name: 'iPhone Repairs', icon: null, logo: appleLogo,
    services: [
      { name: 'Screen Repair', time: '30–45 min', price: '$59–$349', icon: <ScreenIcon />, popular: true },
      { name: 'Battery Replacement', time: '20–30 min', price: '$59–$130', icon: <BatteryIcon /> },
      { name: 'Charging Port Repair', time: '30–60 min', price: '$30–$109', icon: <LightningIcon /> },
      { name: 'Camera Repair', time: '30–60 min', price: '$79–$149', icon: <CameraIcon /> },
      { name: 'Back Glass Repair', time: '45–90 min', price: '$79–$229', icon: <GlassIcon /> },
      { name: 'Water Damage Repair', time: 'Same Day', price: '$49–$149', icon: <WaterIcon /> },
      { name: 'Speaker / Mic Repair', time: '30–60 min', price: '$49–$99', icon: <SpeakerIcon /> },
      { name: 'Home Button Repair', time: '30–60 min', price: '$49–$89', icon: <ButtonIcon /> },
    ],
  },
  {
    name: 'Samsung Repairs', icon: null, logo: samsungLogo,
    services: [
      { name: 'Screen Repair', time: '45–90 min', price: '$79–$349', icon: <ScreenIcon />, popular: true },
      { name: 'Battery Replacement', time: '30–60 min', price: '$59–$99', icon: <BatteryIcon /> },
      { name: 'Charging Port Repair', time: '30–60 min', price: '$59–$99', icon: <LightningIcon /> },
      { name: 'Camera Repair', time: '45–90 min', price: '$79–$169', icon: <CameraIcon /> },
      { name: 'Back Glass Repair', time: '45–90 min', price: '$79–$249', icon: <GlassIcon /> },
      { name: 'Water Damage Repair', time: 'Same Day', price: '$49–$149', icon: <WaterIcon /> },
    ],
  },
  {
    name: 'Other Phones', icon: <PhoneIcon size={18} />, logo: null,
    services: [
      { name: 'Screen Repair', time: '30–60 min', price: '$49–$199', icon: <ScreenIcon /> },
      { name: 'Battery Replacement', time: '20–45 min', price: '$39–$79', icon: <BatteryIcon /> },
      { name: 'Charging Port Repair', time: '30–60 min', price: '$49–$89', icon: <LightningIcon /> },
      { name: 'Water Damage Repair', time: 'Same Day', price: '$49–$129', icon: <WaterIcon /> },
    ],
  },
  {
    name: 'iPad Repairs', icon: <TabletIcon size={18} />, logo: null,
    services: [
      { name: 'Screen Repair', time: '1–2 hours', price: '$89–$299', icon: <ScreenIcon />, popular: true },
      { name: 'Battery Replacement', time: '1–2 hours', price: '$69–$129', icon: <BatteryIcon /> },
      { name: 'Charging Port Repair', time: '1–2 hours', price: '$30–$109', icon: <LightningIcon /> },
      { name: 'Camera Repair', time: '1–2 hours', price: '$79–$149', icon: <CameraIcon /> },
    ],
  },
];

const promiseItems = [
  { icon: <WrenchIcon size={22} />, title: 'Quality Parts Only', desc: 'We use premium-grade components that meet or exceed original manufacturer standards.' },
  { icon: <ShieldIcon size={22} />, title: 'Warranty on All Repairs', desc: 'Every repair comes backed by a warranty so you can trust the work we do.' },
  { icon: <LightningIcon size={22} />, title: 'Fast Turnaround', desc: 'We respect your time. Most repairs are completed while you wait — often under an hour.' },
  { icon: <DollarIcon size={22} />, title: 'Honest & Fair Pricing', desc: "You'll always know the price upfront. No hidden fees, no surprises at pickup." },
];

export default function ServicesPage() {
  const [activeTab, setActiveTab] = useState(0);
  const cat = categories[activeTab];

  return (
    <div className="svc-page">
      {/* ── PAGE HERO ── */}
      <section className="page-hero">
        <div className="page-hero__container">
          <span className="page-hero__tag">Professional Repairs</span>
          <h1 className="page-hero__title">Our Services</h1>
          <p className="page-hero__sub">
            From cracked screens to water damage — we fix it all. Same-day service,
            quality parts, and warranty included on every repair.
          </p>
          <div className="page-hero__pills">
            <span>✓ Same-Day Repairs</span>
            <span>✓ Warranty Included</span>
            <span>✓ Best Prices In Town</span>
          </div>
        </div>
      </section>

      {/* ── SERVICE TABS ── */}
      <section className="svc-page__content">
        <div className="svc-page__container">
          {/* Tab Nav */}
          <div className="svc-page__tabs">
            {categories.map((c, i) => (
              <button
                key={i}
                className={`svc-page__tab ${activeTab === i ? 'svc-page__tab--active' : ''}`}
                onClick={() => setActiveTab(i)}
              >
                {c.logo
                  ? <img src={c.logo} alt={c.name} className="svc-page__tab-logo" />
                  : <span className="svc-page__tab-icon">{c.icon}</span>
                }
                <span>{c.name}</span>
              </button>
            ))}
          </div>

          {/* Service Grid */}
          <div className="svc-page__category">
            <div className="svc-page__cat-header">
              <div className="svc-page__cat-icon">
                {cat.logo
                  ? <img src={cat.logo} alt={cat.name} className="svc-page__cat-logo" />
                  : <span className="svc-page__cat-icon-svg">{cat.icon}</span>
                }
              </div>
              <div>
                <h2 className="svc-page__cat-title">{cat.name}</h2>
                <p className="svc-page__cat-sub">{cat.services.length} services available · Most done same day</p>
              </div>
            </div>
            <div className="svc-page__grid">
              {cat.services.map((s, i) => (
                <div className={`svc-card ${s.popular ? 'svc-card--popular' : ''}`} key={i}>
                  {s.popular && <div className="svc-card__badge">Most Popular</div>}
                  <div className="svc-card__icon">{s.icon}</div>
                  <div className="svc-card__body">
                    <h3 className="svc-card__name">{s.name}</h3>
                    <div className="svc-card__meta">
                      <span className="svc-card__time">{s.time}</span>
                      <span className="svc-card__price">{s.price}</span>
                    </div>
                  </div>
                  <Link to="/quote" className="svc-card__cta">Get Quote →</Link>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="svc-page__cta">
            <div className="svc-page__cta-text">
              <h3>Don't see your device or issue?</h3>
              <p>We likely still fix it. Call us or get an instant quote — no charge for diagnostics.</p>
            </div>
            <div className="svc-page__cta-actions">
              <a href="tel:9372350298" className="svc-page__btn svc-page__btn--primary">Call (937) 235-0298</a>
              <Link to="/quote" className="svc-page__btn svc-page__btn--outline">Get Instant Quote</Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── PROMISE ── */}
      <section className="svc-promise">
        <div className="svc-promise__container">
          <h2 className="svc-promise__title">Our Service Promise</h2>
          <div className="svc-promise__grid">
            {promiseItems.map((item, i) => (
              <div className="svc-promise__item" key={i}>
                <div className="svc-promise__icon">{item.icon}</div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
